<div
    class="menu-items"
    (animationend)="onAnimationEnd($event)"
    [class.is-mac]="isMacOS()"
    (click)="$event.stopPropagation()"
>
    <div class="main-menu">
        @for (item of mainMenuItems; track item.label) {
            @if (isItemVisible(item)) {
                <div class="menu-item" (click)="onMenuItemClick(item)">
                    <img [src]="item.icon" [alt]="item.label" class="menu-icon" />
                    <span class="menu-label">{{ item.label }}</span>
                </div>
            }
        }
    </div>

    <div class="bottom-menu">
        @for (item of bottomMenuItems; track item.label) {
            @if (isItemVisible(item)) {
                <div class="menu-item" (click)="onMenuItemClick(item)">
                    <img [src]="item.icon" [alt]="item.label" class="menu-icon" />
                    <span class="menu-label">{{ item.label }}</span>
                </div>
            }
        }
    </div>
    @if (appVersion()) {
        <div class="app-info">
            <span class="app-version">{{ appVersion() }}</span>
            <span class="staging-label" [hidden]="!isStaging()">STAGING</span>
        </div>
    }
</div>
